import Vue from 'vue';
import { toYuan } from '../../utils/unit-conversion';
export default Vue.extend({
    name: 'balanceSuccess',
    data: function () {
        return {
            params: {},
        };
    },
    created: function () {
        this.params = this.$route.params;
    },
    computed: {
        amount: function () {
            return toYuan(this.params.amount);
        },
        actualAmount: function () {
            return toYuan(this.params.actualAmount);
        },
        bankName: function () {
            return this.params.bankName;
        },
        cardTailNo: function () {
            return this.params.cardTailNo;
        },
    },
    methods: {
        backBalance: function () {
            this.$router.push({ name: 'balanceAccountOverview' });
        },
    },
});
